import { Injectable } from '@angular/core';
import { Description } from 'src/app/analysis/models/Description';
import { User } from 'src/app/analysis/models/User';
import { TextValue } from '../../analysis/models/criterions/TextValue';
import { AnalysisI18nText } from 'src/app/analysis/models/AnalysisI18nText';
import { map, Observable } from 'rxjs';
import { SelectListOption } from '@bmw-ds/components';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class TranslationUtils {
    public static translateTextValue(textValue: Description | TextValue, language?: string): string {
        let translation: string | undefined;
        if (textValue == null) {
            return 'DE';
        }
        switch (language) {
            case 'DE':
                translation = textValue.textDE;
                break;
            case 'EN':
                translation = textValue.textEN;
                break;
            case 'ES':
                translation = textValue.textES;
                break;
            case 'PT':
                translation = textValue.textPT;
                break;
            case 'CN':
                translation = textValue.textCN;
                break;
            case 'HU':
                translation = textValue.textHU;
                break;
            default:
                translation = textValue.textEN;
        }
        return translation ?? textValue.textEN ?? '';
    }

    public static setTranslation(textValue: Description | TextValue, language?: string | null, translation?: string) {
        switch (language) {
            case 'DE':
                textValue.textDE = translation;
                break;
            case 'EN':
                textValue.textEN = translation;
                break;
            case 'ES':
                textValue.textES = translation;
                break;
            case 'PT':
                textValue.textPT = translation;
                break;
            case 'CN':
                textValue.textCN = translation;
                break;
            case 'HU':
                textValue.textHU = translation;
                break;
            default:
                textValue.textEN = translation;
        }
    }

    public static getUserDisplayName(user: User): string {
        const safeFirstName = user?.firstName ?? '';
        const safeLastName = user?.lastName ?? '';
        return `${safeLastName}, ${safeFirstName}`;
    }

    public static appendTxtSuffix(errCode: string): string {
        return errCode.endsWith('.TXT') ? errCode : `${errCode}.TXT`;
    }

    public static appendERRORPrefix(errCode: string): string {
        return errCode.startsWith('ERROR.') ? errCode : `ERROR.${errCode}`;
    }

    public static getI18nText(list: AnalysisI18nText[] | undefined, textType: string, userLanguage: string | undefined, fallback: string | undefined): string {
        const userText = list?.find(t => t.textType === textType && t.languageCode?.toLowerCase() === userLanguage?.toLowerCase());
        const englishText = list?.find(t => t.textType === textType && t.languageCode?.toLowerCase() === 'en');

        return userText?.text ?? englishText?.text ?? fallback ?? '';
    }

    public static translateOptions(options$: Observable<SelectListOption[]>, translateService: TranslateService): Observable<SelectListOption[]> {
        return options$.pipe(map(options => options.map(option => ({ ...option, label: translateService.instant(option.label) }))));
    }
}
